import smallCircle from '../../../assets/images/production/dataGovernance/ball-s.png'
import fmdb from '../../../assets/images/production/bigdata/FMDB_Nomal.png'
import fmdbActive from '../../../assets/images/production/bigdata/FMDB_Hover.png'
import fx from '../../../assets/images/production/bigdata/fx_Nomal.png'
import fxActive from '../../../assets/images/production/bigdata/fx_Hover.png'
import fbp from '../../../assets/images/production/bigdata/FDP_Nomal.png'
import fbpActive from '../../../assets/images/production/bigdata/FDP_Hover.png'
import leftBall from '../../../assets/images/production/applicationDev/left-ball.png'
import circle from '../../../assets/images/production/bigdata/circle.png'
import img from '../../../assets/images/production/bigdata/02.png'
import fmdbImg from '../../../assets/images/production/bigdata/FMDB.jpg'
import FDP from '../../../assets/images/production/bigdata/fdp.png'

import { Tabs } from 'antd'
import styles from './style.module.scss'

const applicationList = [
  {
    key: '1',
    label: (
      <div className={styles['application-label']}>
        <img className={styles['normal']} src={fx} alt="" />
        <img
          className={styles['active']}
          src={fxActive}
          alt=""
        />
      </div>
    ),
    content: (
      <>
        <div
          className={`introduction-container ${styles['introduction-container']}`}
        >
          <p>
            产品简介
            <img src={smallCircle} alt="" />
          </p>
          <div
            className={`introduction-title ${styles['introduction-title']}`}
          >
            <div
              className={`title-wrapper ${styles['title-wrapper']}`}
            >
              <img src={leftBall} alt="" />
              <div
                className={`title-container ${styles['title-container']}`}
              >
                <div>
                  <p>
                    <span>伏羲</span>
                    <span>—— 大数据平台</span>
                  </p>
                  <p>
                    一款为业务而生的大数据存算一体平台，将大数据能力与容器化云平台进行深度整合，融合了多元算力，为用户提供高速、灵活、稳定的大数据计算能力以及海量、安全、低成本、高可靠的大数据存储能力，在大幅提升资源利用率的同时，提供统一集中的租户管理及统一运营，实现了全栈集成运管和调度。
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`introduction-content ${styles['introduction-content']}`}
          >
            <img src={circle} alt="" />
            <div>
              <img src={img} alt="" />
            </div>
          </div>
        </div>
        <div className={styles['feature-container']}>
          <p>产品特色</p>
          <div className={styles['feature-content']}>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div className={styles['img']}></div>
              <p>适用于万亿级海量数据存储和分析</p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div className={styles['img']}></div>
              <p>
                适用于时空分析、图数融合、可视化报表分析、网络安全态势分析、超海量数据地挖掘分析等多种实战业务场景
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div className={styles['img']}></div>
              <p>数据存储相比传统大数据方案降低60%</p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div className={styles['img']}></div>
              <p>
                十亿级表碰撞分钟级响应，相比传统大数据方案分析性能提升10倍
              </p>
            </div>
          </div>
        </div>
      </>
    )
  },
  {
    key: '2',
    label: (
      <div className={styles['application-label']}>
        <img
          className={styles['normal']}
          src={fmdb}
          alt=""
        />
        <img
          className={styles['active']}
          src={fmdbActive}
          alt=""
        />
      </div>
    ),
    content: (
      <>
        <div
          className={`introduction-container ${styles['introduction-container']}`}
        >
          <p>
            产品简介
            <img src={smallCircle} alt="" />
          </p>
          <div
            className={`introduction-title ${styles['introduction-title']}`}
          >
            <div
              className={`title-wrapper ${styles['title-wrapper']}`}
            >
              <img src={leftBall} alt="" />
              <div
                className={`title-container ${styles['title-container']}`}
              >
                <div>
                  <p>
                    <span>FMDB</span>
                    <span>—— 烽火海量数据库</span>
                  </p>
                  <p>
                    一款针对超大规模数据存储设计的数据管理系统，在具备通用大数据产品查询分析能力的基础上，针对行业的特点，进行了诸多增强和优化。FMDB在架构设计上遵循“一份数据+多份索引”的设计思想，基于HSAP理念设计“查分一体”计算引擎
                    和“行列混合”存储引擎，致力于解决行业大数据开发中面临的存储冗余、计算资源不足等一系列问题。实现了存储计算一体化、接口服务标准化、智能运管化，为信息化建设提供了有效地支撑。
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`introduction-content ${styles['introduction-content']}`}
          >
            <img src={circle} alt="" />
            <div>
              <img src={fmdbImg} alt="" />
            </div>
          </div>
        </div>
        <div className={styles['feature-container-fmdb']}>
          <p>产品特色</p>
          <div className={styles['feature-content']}>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>接口丰富</span>
              </div>
              <p>
                提供标准JDBC
                SQL和python访问方式，能够审核拦截不规范SQL，防止恶意访问和攻击
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>算子下沉</span>
              </div>
              <p>
                基于行业特征的算子下沉，内置100+算子和专项优化的高性能算子，减少计算数据拷贝出库，提升计算效率{' '}
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>智能技术</span>
              </div>
              <p>
                通过SQL预编译智能匹配、大任务智能限流、丰富的SQL优化器（HBO、CBO、RBO、DBO）、计算漂移等技术，进一步提高任务资源利用率和运行效率
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>高效存储</span>
              </div>
              <p>
                “块数据”、“块索引”存储技术，数据整存整取，有效降低数据占用空间，相比较原始数据存储压缩率在20%~40%左右。
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>计算加速</span>
              </div>
              <p>
                采用冷热分离、位图计算、Native引擎、粗粒度索引等多种加速技术，减少参与计算数据规模，提升计算性2倍以上
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>安全开放</span>
              </div>
              <p>
                通过租用户体系对计算资源分配隔离，数据资源提供库、表级授权开放，采用可视化任务管理器可对任务暂停、恢复等管理操作
              </p>
            </div>
          </div>
        </div>
        <div
          className={styles['feature-container']}
          style={{ background: '#f5f7fc' }}
        >
          <p>证书认证</p>
          <div className={styles['feature-content']}>
            <div
              className={`cer-item-fmdb  ${styles['cer-item-fmdb']}`}
            >
              <div
                className={`cer1  ${styles['cer1']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fmdb  ${styles['cer-item-fmdb']}`}
            >
              <div
                className={`cer2  ${styles['cer2']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fmdb  ${styles['cer-item-fmdb']}`}
            >
              <div
                className={`cer3  ${styles['cer3']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fmdb  ${styles['cer-item-fmdb']}`}
            >
              <div
                className={`cer4  ${styles['cer4']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fmdb  ${styles['cer-item-fmdb']}`}
            >
              <div
                className={`cer5  ${styles['cer5']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fmdb  ${styles['cer-item-fmdb']}`}
            >
              <div
                className={`cer6  ${styles['cer6']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fmdb  ${styles['cer-item-fmdb']}`}
            >
              <div
                className={`cer7  ${styles['cer7']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fmdb  ${styles['cer-item-fmdb']}`}
            >
              <div
                className={`cer8  ${styles['cer8']}`}
              ></div>
            </div>
          </div>
        </div>
      </>
    )
  },
  {
    key: '3',
    label: (
      <div className={styles['application-label']}>
        <img
          className={styles['normal']}
          src={fbp}
          alt=""
        />
        <img
          className={styles['active']}
          src={fbpActive}
          alt=""
        />
      </div>
    ),
    content: (
      <>
        <div
          className={`introduction-container ${styles['introduction-container']}`}
        >
          <p>
            产品简介
            <img src={smallCircle} alt="" />
          </p>
          <div
            className={`introduction-title ${styles['introduction-title']}`}
          >
            <div
              className={`title-wrapper ${styles['title-wrapper']}`}
            >
              <img src={leftBall} alt="" />
              <div
                className={`title-container ${styles['title-container']}`}
              >
                <div>
                  <p>
                    <span>FDP </span>
                    <span>—— 烽火星空数据接入工具</span>
                  </p>
                  <p>
                    烽火星空数据接入工具是一款可视化的数据接入工具，具备多端到多端的数据灵活摆渡的能力，帮助公司快速解决异构数据源之间数据传输问题。
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`introduction-content ${styles['introduction-content']}`}
          >
            <img src={circle} alt="" />
            <div style={{ background: '#e2edfe' }}>
              <img src={FDP} alt="" />
            </div>
          </div>
        </div>
        <div className={styles['feature-container']}>
          <p>产品特色</p>
          <div className={styles['feature-content']}>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>自动化建表能力</span>
              </div>
              <p>
                支持跨数据库间自动建表的能力，库与库间支持互转：MySQL、Oracle、达梦、PostgreSQL、SQLServer、华为GaussDB、人大金仓、FP、FMDB、HBase、Hive
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>水平扩展能力</span>
              </div>
              <p>
                支持界面化扩容节点引擎增加数据处理能力，支持以及节点的上线、下线、升级操作，支持界面化一键操作{' '}
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span>跨平台迁移能力</span>
              </div>
              <p>
                支持市面上不同厂商大数据平台之间的数据迁移，帮助您省去跨平台数据传输的各类烦恼
              </p>
            </div>
            <div
              className={`feature-item ${styles['feature-item']}`}
            >
              <div
                className={`feature-item-title ${styles['feature-item-title']}`}
              >
                <div className={styles['img']}></div>
                <span> 按日志增量抽取</span>
              </div>
              <p>
                支持oracle、达梦的logminer方式抽取，支持mysql的binlog抽取，支持自定义触发器方式抽取
              </p>
            </div>
          </div>
        </div>
        <div
          className={styles['feature-container']}
          style={{ background: '#f5f7fc' }}
        >
          <p>资深技术工程师保驾护航</p>
          <div className={styles['feature-content']}>
            <div
              className={`cer-item-fdp ${styles['cer-item-fdp']}`}
            >
              <div
                className={`cer1  ${styles['cer1']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fdp ${styles['cer-item-fdp']}`}
            >
              <div
                className={`cer2  ${styles['cer2']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fdp ${styles['cer-item-fdp']}`}
            >
              <div
                className={`cer3  ${styles['cer3']}`}
              ></div>
            </div>
            <div
              className={`cer-item-fdp ${styles['cer-item-fdp']}`}
            >
              <div
                className={`cer4  ${styles['cer4']}`}
              ></div>
            </div>
          </div>
        </div>
      </>
    )
  }
]

function BigData() {
  return (
    <div
      className={`production-introduction-wrapper ${styles['application-dev-wrapper']}`}
    >
      <div className={`banner ${styles['banner']}`}>
        <div className="title">大数据智能化产品</div>
        <div className={`content ${styles['content']}`}>
          烽火星空大数据智能化系列产品作为行业解决方案的核心技术支撑，主要包括大数据平台、数据治理工具、分析建模工具、应用开发工具，贯穿数据的存算、分析、应用、展示全生命周期，是新时代信息领域的“大国重器”
        </div>
      </div>

      <div className={styles['application-dev-container']}>
        <Tabs
          defaultActiveKey="1"
          centered
          destroyInactiveTabPane
          items={applicationList.map((item) => ({
            label: item.label,
            key: item.key,
            children: item.content
          }))}
        />
      </div>
    </div>
  )
}

export default BigData
